import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Label, Alert } from "reactstrap";
import CustomHeader from "../../../Components/Common/CustomHeader";
import Select from 'react-select';
import { useTemplatesModal, ChannelType } from "../hooks/useTemplatesModal";

type SendTemplateModalProps = {
    isOpen: boolean;
    onToggle: () => void;
    onSend: (templateId: string, templateName: string, channel: ChannelType) => void;
};

export const SendTemplateModal: React.FC<SendTemplateModalProps> = ({ isOpen, onToggle, onSend }) => {
    const { channel, setChannel, templates, isLoading, error } = useTemplatesModal(isOpen);
    const [selectedTemplate, setSelectedTemplate] = useState<any>(null);

    // Reset selected template when channel changes
    useEffect(() => {
        setSelectedTemplate(null);
    }, [channel]);

    const handleSend = () => {
        if (selectedTemplate) {
            onSend(selectedTemplate.value, selectedTemplate.label, channel);
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={onToggle} centered contentClassName="border-0 rounded-4 shadow overflow-hidden">
            <CustomHeader title="Envio de Plantilla" onClose={onToggle} component={ModalHeader} />
            <ModalBody>
                {/* Channel Selector */}
                <div className="mb-4">
                    <Label className="form-label d-block text-muted text-uppercase fs-12 fw-bold">Canal de Envío</Label>
                    <div className="btn-group w-100" role="group">
                        <input type="radio" className="btn-check" name="channelRadio" id="whatsappRadio"
                            checked={channel === 'WhatsApp'} onChange={() => setChannel('WhatsApp')} />
                        <label className="btn btn-outline-success w-50" htmlFor="whatsappRadio">
                            <i className="ri-whatsapp-line align-middle me-1"></i> WhatsApp
                        </label>

                        <input type="radio" className="btn-check" name="channelRadio" id="emailRadio"
                            checked={channel === 'Correo'} onChange={() => setChannel('Correo')} />
                        <label className="btn btn-outline-primary w-50" htmlFor="emailRadio">
                            <i className="ri-mail-line align-middle me-1"></i> Correo
                        </label>
                    </div>
                </div>

                {error && <Alert color="danger">{error}</Alert>}
                <div className="mb-3">
                    <Label className="form-label">Seleccione una plantilla</Label>
                    <Select
                        options={templates}
                        value={selectedTemplate}
                        onChange={setSelectedTemplate}
                        placeholder="Escriba para buscar una plantilla..."
                        isLoading={isLoading}
                        isClearable
                        noOptionsMessage={() => "No se encontraron plantillas"}
                    />
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="light" onClick={onToggle}>Cancelar</Button>
                <Button color="primary" onClick={handleSend} disabled={!selectedTemplate || isLoading}>
                    Enviar Template
                </Button>
            </ModalFooter>
        </Modal>
    );
};
